export const sectors = {
    "Agriculture": "Ag", 
    "Industrial": "Industrial", 
    "Coal electric generation": "Coal_Elec",
    "Noncoal electric generation" : "Non-Coal_Elec",
    "Residential wood combustion": "Res_Wood",
    "Residential gas combustion": "Res_Gas",
    "Residential other": "Res_Other",
    "Road dust": "Road_Dst",
    "Commercial cooking": "Cooking",
    "Miscellaneous": "Misc",
    "Off-highway vehicles & equipments": "Offroad",
    "Construction": "Const",
    "Heavy duty diesel vehicles": "Diesel_HD_Veh",
    "Light duty gasoline vehicles": "Gas_LD_Veh",
}
  